import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import "./App.css";
import Login from './pages/Login';
import LandingPage from './pages/LandingPage';
import Otp from './pages/Otp.jsx';
import ListFiles from './pages/documents/ListFiles.jsx';
import Unauthorized from './pages/Unauthorized.jsx';
import { AuthProvider } from './pages/context/AuthContext.jsx';
import ProtectedRoute from './pages/context/ProtectedRoute.jsx';
import Dashboard from './pages/Dashboard.jsx';
import UsersManagement from './pages/users/UsersManagement.jsx';
import DocsManagement from './pages/documents/DocsManagement.jsx';
import UppyUpload from './pages/documents/Uploader.jsx';
import { Roles } from './roles.js';
import Loading from './pages/Loading.jsx';
import RedirectIfAuthenticated from './pages/context/RedirectIfAuthenticated.jsx';
import PolicyPage from './pages/Policy.jsx';
import TermsOfUse from './pages/TermOfUse.jsx';

export default function App() {
  const { lang } = useParams();
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();

  useEffect(() => {
    if (!["en", "km"].includes(lang)) {
      navigate("/lang/km", { replace: true });
      return;
    }

    i18n.changeLanguage(lang).then(() => {
      document.title = t("app.title");
    });
  }, [lang, i18n, navigate]);

  return (
    <AuthProvider>
      <Routes>
        {/* All app routes go inside here */}
        <Route path="/*" element={<AppWithLanguageContext />} />
      </Routes>
    </AuthProvider>
  );
}

const AppWithLanguageContext = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route element={<RedirectIfAuthenticated />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verify-otp" element={<Otp />} />
      </Route>

      <Route path="/loading" element={<Loading />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/policy" element={<PolicyPage />} />
      <Route path="/term" element={<TermsOfUse />} />

      {/* Protected routes: USER + ADMIN + SUPERADMIN */}
      <Route element={<ProtectedRoute roles={[Roles.USER, Roles.ADMIN, Roles.SUPERADMIN]} />}>
        <Route path="/upload" element={<UppyUpload />} />
        <Route path="/files/:username" element={<ListFiles />} />
        <Route path="/admin/dashboard" element={<Dashboard />} />
      </Route>

      {/* Protected routes: ADMIN + SUPERADMIN */}
      <Route element={<ProtectedRoute roles={[Roles.ADMIN, Roles.SUPERADMIN]} />}>
        <Route path="/admin/doc-manager" element={<DocsManagement />} />
        <Route path="/admin/user-manager" element={<UsersManagement />} />
      </Route>

      {/* Fallback: redirect to login */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};
